import BarHighChart from '@components/_elements/BarHighChart/BarHighChart';

interface WindProductionProps {
  loading: boolean;
  data: { date: string; value: number }[];
}

function WindProduction({ loading, data }: WindProductionProps) {
  return (
    <BarHighChart
      variables={false}
      isAxesInvisible
      unit='MWh'
      name='Index'
      barsClasses={[1]}
      loading={loading}
      hourly
      margins={{ top: 10, right: 5, bottom: 10, left: 5 }}
      data={data}
    />
  );
}

export default WindProduction;
